import { render } from "./ParoleResults.vue?vue&type=template&id=6cf2c966&scoped=true"
import script from "./ParoleResults.vue?vue&type=script&lang=js"
export * from "./ParoleResults.vue?vue&type=script&lang=js"

import "./ParoleResults.vue?vue&type=style&index=0&id=6cf2c966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf2c966"]])

export default __exports__